import { BaseDto } from './base.dto';
import { StockLocationDto } from './stockLocation.dto';

export class StockStockLocationDto extends BaseDto {
  stockId: number;
  stockLocationId: number;
  stockLocation?: StockLocationDto;
  sequence: number;
}